import { APPLICATION_TYPE } from '@shared/constants';
import api from '@shared/api';

const workspaceApi = {
  fetchAllWorkspacesForUser() {
    const url = `workspaces`;
    return api.get(url, {
      params: {
        withoutExtendedData: true
      }
    });
  },

  validateTeamName(teamName) {
    const data = { teamName };
    const url = `workspaces/validate`;
    return api.post(url, data);
  },

  removeTeamMember(data) {
    const url = `workspaces/removeFromTeam`;
    return api.post(url, data);
  },

  fetchOrganizationWorkspaces(organizationId) {
    const url = `workspaces`;
    return api.get(url, {
      params: {
        organizationId,
        withoutExtendedData: true
      }
    });
  },

  fetchWorkspaceMembers(workspaceId, cancelToken) {
    const url = `workspaces/${workspaceId}/getAllMembers`;
    return api.get(url, { cancelToken });
  },

  createWorkspace({ organizationId, name }) {
    const url = `workspaces`;
    return api.post(url, {
      organizationId,
      name
    });
  },

  deleteWorkspace(workspaceId) {
    const url = `workspaces/${workspaceId}`;
    return api.delete(url);
  },

  fetchInvitesForWorkspace(workspaceId, cancelToken) {
    const url = `workspaces/list-email-invites?teamId=${workspaceId}`;
    return api.get(url, { cancelToken });
  },

  setUsersDefaultWorkspace(workspaceId) {
    const data = {
      teamId: workspaceId
    };
    const url = `workspaces/default/set`;
    return api.post(url, data);
  },

  inviteUserByEmailToWorkspace(workspaceId, shareWithEmail, app) {
    const data = {
      teamId: workspaceId,
      shareWithEmail
    };
    const url =
      app === APPLICATION_TYPE.llm
        ? `workspaces/invite-llm`
        : `workspaces/invite`;
    return api.post(url, data);
  },

  addWorkspaceMemberBulk({ app, users }) {
    if (app === APPLICATION_TYPE.llm) {
      return api.post(`workspaces/invite-usernames-llm`, {
        userNames: users.map(user => user.userName),
        workspaceId: users[0].teamId
      });
    }

    return api.post(`workspaces/addToWorkspaceBulk`, {
      users
    });
  },

  claimInviteWorkspaceCode(workspaceCode) {
    const url = `workspaces/claim?workspaceCode=${workspaceCode}`;
    return api.get(url);
  },

  claimAnonymousData(workspaceName, isNewUser) {
    const data = {
      workspaceName,
      isNewUser
    };
    const url = `workspaces/claimData`;
    return api.post(url, data);
  }
};

export default workspaceApi;
